import { useState } from "react";
import { FreeMantenimientoDiarioTab } from './FreeMantenimientoDiarioTab';
import { FreeMantenimientoSemanalTab } from './FreeMantenimientoSemanalTab';
import { FreeMantenimientoMensualTab } from './FreeMantenimientoMensualTab';

// ── PLAN FREE: Plan Mantenimiento Instalaciones (Diario/Semanal/Mensual) ──
export const FreeMantenimientoForm = () => {
  const [tab, setTab] = useState("Diario");

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl shadow p-4">
        <h2 className="font-bold text-gray-800 border-b pb-2 mb-3">🏭 Plan Mantenimiento Instalaciones</h2>
        <div className="flex gap-2 bg-gray-50 rounded-xl p-2">
          {[["Diario", "📅 Diario"], ["Semanal", "📆 Semanal"], ["Mensual", "📋 Mensual"]].map(([t, l]) => (
            <button key={t} onClick={() => setTab(t)} className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${tab === t ? "bg-blue-600 text-white" : "text-gray-500 hover:bg-gray-100"}`}>{l}</button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow p-4">
        {tab === "Diario" && <FreeMantenimientoDiarioTab />}
        {tab === "Semanal" && <FreeMantenimientoSemanalTab />}
        {tab === "Mensual" && <FreeMantenimientoMensualTab />}
      </div>
    </div>
  );
};
